import { makeVar } from '@apollo/client'

import { CustomerType } from './getCustomer.types'

export const rvCurrentUserData = makeVar<CustomerType | null>(null)
